module.exports = __webpack_public_path__ + "4aa8c05eb7d027f130fa3ac7ebaa0651.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/social-media/facebook-logo-coloured.png
 ** module id = 486
 ** module chunks = 0
 **/